import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { BhEditorToolboxComponent } from './bh-editor-toolbox.component';

@NgModule({
  declarations: [BhEditorToolboxComponent],
  imports: [CommonModule, FormsModule, IonicModule],
  exports: [BhEditorToolboxComponent],
})
export class BhEditorToolboxComponentModule {}
